<template>
  <div id="motions-page" class="page-wrapper">
    <h1 class="page-title">Motions</h1>

    <!-- Easing Tokens -->
    <section class="token-section">
      <!-- <h2 class="m-t-40">Easing Curves</h2> -->
      <h2>Standard Ease</h2>
      <div class="token-grid">
        <div v-for="(ease, name) in standardEase" :key="name" class="token-card">
          <div
            class="animation-box"
            :style="{ animationTimingFunction: ease }"
          ></div>
          <div class="token-info">
            <code>{{ name }}</code>
            <span>{{ ease }}</span>
          </div>
        </div>
      </div>

      <h2>Entrance</h2>
      <div class="token-grid">
        <div v-for="(ease, name) in entranceEase" :key="name" class="token-card">
          <div
            class="animation-box entrance"
            :style="{ animationTimingFunction: ease }"
          ></div>
          <div class="token-info">
            <code>{{ name }}</code>
            <span>{{ ease }}</span>
          </div>
        </div>
      </div>

      <h2>Exit</h2>
      <div class="token-grid">
        <div v-for="(ease, name) in exitEase" :key="name" class="token-card">
          <div
            class="animation-box exit"
            :style="{ animationTimingFunction: ease }"
          ></div>
          <div class="token-info">
            <code>{{ name }}</code>
            <span>{{ ease }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Duration Tokens -->
    <section class="token-section">
      <h2>Duration Tokens</h2>
      <div class="token-grid">
        <div v-for="(duration, name) in durations" :key="name" class="token-card">
          <div
            class="animation-box"
            :style="{ animationDuration: duration }"
          ></div>
          <div class="token-info">
            <code>{{ name }}</code>
            <span>{{ duration }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      durations: {
        '$motion-duration-fast-1': '50ms',
        '$motion-duration-fast-2': '150ms',
        '$motion-duration-medium-1': '250ms',
        '$motion-duration-medium-2': '350ms',
        '$motion-duration-slow-1': '450ms',
        '$motion-duration-slow-2': '650ms'
      },
      standardEase: {
        '$motion-soft-ease': 'cubic-bezier(0.600, 0.000, 0.300, 1.000)',
        '$motion-productive-ease': 'cubic-bezier(0.300, 0.000, 0.300, 1.000)',
        '$motion-alert-ease': 'cubic-bezier(0.300, 0.000, 0.040, 1.300)'
      },
      entranceEase: {
        '$motion-soft-entrance': 'cubic-bezier(0.300, 0.600, 0.500, 1.000)',
        '$motion-productive-entrance': 'cubic-bezier(0.200, 0.600, 0.500, 1.000)',
        '$motion-alert-entrance': 'cubic-bezier(0.200, 0.700, 0.300, 1.300)'
      },
      exitEase: {
        '$motion-soft-exit': 'cubic-bezier(0.400, 0.000, 0.700, 0.400)',
        '$motion-productive-exit': 'cubic-bezier(0.300, 0.000, 0.700, 0.400)'
      }
    }
  }
}
</script>

<style lang="scss">
#motions-page {
  display: flex;
  flex-direction: column;
}

  code {
    font-size: 14px !important;
    color: $color-cool-grey-700 !important;
  }

.token-section {

  h2 {
    margin-bottom: 1.5rem;
  }

  h3 {
    margin: 2rem 0 1rem;
  }
}

.token-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.token-card {
  padding: 1.5rem;
  border: 1px solid #eee;
  border-radius: 8px;
  background: white;
}

.animation-box {
  width: 60px;
  height: 60px;
  background: $color-primary-500;
  border-radius: 4px;
  margin-bottom: 1rem;
  animation: slide 2s infinite;

  &.entrance {
    animation: entrance 2s infinite;
  }

  &.exit {
    animation: exit 2s infinite;
  }
}

.token-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  code {
    font-family: monospace;
    color: #666;
  }

  span {
    font-size: 0.9em;
    color: #888;
  }
}

@keyframes slide {
  0% { transform: translateX(0); }
  50% { transform: translateX(200px); }
  100% { transform: translateX(0); }
}

@keyframes entrance {
  0% { transform: translateY(50px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}

@keyframes exit {
  0% { transform: scale(1); opacity: 1; }
  100% { transform: scale(0.8); opacity: 0; }
}
</style>
